import { Link } from "react-router-dom";

/**
 * Slim legal + support footer for public marketing/onboarding pages.
 * Not shown in the authenticated app shell.
 */
export default function LegalFooter({ variant = "default" }) {
  return (
    <footer className={`legal-footer legal-footer-${variant}`} data-testid="legal-footer">
      <div className="legal-footer-inner">
        <div className="legal-footer-brand">
          <b>Mi Contador</b>
          <small>Tu contador amigable en México</small>
        </div>
        <nav className="legal-footer-links" aria-label="Enlaces legales">
          <Link to="/legal/privacidad" data-testid="footer-privacy">Aviso de Privacidad</Link>
          <Link to="/legal/terminos" data-testid="footer-terms">Términos y Condiciones</Link>
          <Link to="/legal/cookies" data-testid="footer-cookies">Política de Cookies</Link>
          <a href="mailto:micontador.appmx@gmail.com" data-testid="footer-contact">Contacto</a>
          <a href="mailto:micontador.appmx@gmail.com" data-testid="footer-support">Soporte</a>
        </nav>
        <small className="legal-footer-copy">© {new Date().getFullYear()} Mi Contador · Hecho con cariño en México.</small>
      </div>
    </footer>
  );
}
